export default ['jpg', 'png', 'gif', 'jpeg', 'svg', 'avif', 'webp', 'jfif'];
